import type { Setup } from './api';
import { STATE_WORD, STEPS } from './format';

const TAPE = '#F2C230';
const PROBLEM = '#B42318';
const INK = '#1B2229';

/**
 * The setup strip: a short tape measure, one section per setup step, filled in yellow as setup
 * moves forward. Pale = under way, red = stopped working, white = not started.
 */
export function Strip({ setup, seg = 36 }: { setup: Setup; seg?: number }) {
  const h = 14;
  const w = seg * STEPS.length;
  const label = `Setup: ${STEPS.map((s) => `${s.name} ${STATE_WORD[setup[s.key]]}`).join(', ')}`;
  const ticks: number[] = [];
  for (let x = 6; x < w; x += 6) ticks.push(x);
  return (
    <svg className="strip" width={w + 2} height={h + 2} viewBox={`-1 -1 ${w + 2} ${h + 2}`} role="img" aria-label={label}>
      <title>{label}</title>
      <rect x={0} y={0} width={w} height={h} rx={2} fill="#fff" />
      {STEPS.map((s, i) => {
        const state = setup[s.key];
        const x = i * seg;
        if (state === 'done') return <rect key={s.key} x={x} y={0} width={seg} height={h} fill={TAPE} />;
        if (state === 'pending') return <rect key={s.key} x={x} y={0} width={seg / 2} height={h} fill={TAPE} fillOpacity={0.45} />;
        if (state === 'broken') return <rect key={s.key} x={x} y={0} width={seg} height={h} fill={PROBLEM} />;
        return null;
      })}
      {ticks.map((x) => {
        const major = x % seg === 0;
        return <line key={x} x1={x} x2={x} y1={0} y2={major ? h : 4} stroke={INK} strokeOpacity={major ? 0.9 : 0.45} strokeWidth={1} />;
      })}
      <rect x={0} y={0} width={w} height={h} rx={2} fill="none" stroke={INK} strokeWidth={1.2} />
    </svg>
  );
}

/** What the strip means, under the clients list. */
export function StripKey() {
  return (
    <div className="key">
      <Strip setup={{ number: 'done', tenDlc: 'done', logins: 'pending', calendar: 'todo', live: 'todo' }} />
      <span>Setup, left to right: {STEPS.map((s) => s.name.toLowerCase()).join(', ').replace('10dlc', '10DLC')}. Yellow is done, pale is under way, red stopped working.</span>
    </div>
  );
}
